"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const handlers_1 = require("./handlers");
const parseLine = (reply) => {
    const m = /^(.*?\r\n)/.exec(reply);
    return m ? m[1] : undefined;
};
const parseCode = (reply) => {
    const m = /^(\d{3}).*?\r\n/.exec(reply);
    return m ? parseInt(m[1]) : undefined;
};
const parseBlock = (reply) => {
    // empty block
    if (reply.startsWith('.\r\n')) {
        return { lines: [], _i: 3 };
    }
    // non-empty block
    const i = reply.indexOf('\r\n.\r\n');
    if (i === -1)
        return undefined;
    const block = reply.slice(0, i);
    const lines = block.split('\r\n').map(l => (l.startsWith('.') ? l.slice(1) : l)); // "dot-stuffing" MUST be undone
    return { lines, _i: i + 5 };
};
const parseArgs = (line, numArgs) => {
    const s = line.slice(0, line.length - 2).split(' ');
    const args = s.slice(1, numArgs + 1);
    const comment = s.slice(numArgs + 1).join(' ');
    return { args, comment };
};
const parse = (command, buffer) => {
    const line = parseLine(buffer);
    if (!line)
        return undefined;
    const code = parseCode(line);
    if (!code)
        return undefined;
    const handler = handlers_1.default(command, code);
    if (!handler)
        throw new Error(`Unhandled command ${command} and code ${code} combination`);
    let block;
    if (handler.multiLine) {
        block = parseBlock(buffer.slice(line.length));
        if (!block)
            return undefined;
    }
    const parsedArgs = parseArgs(line, handler.numberOfArgs);
    const response = handler.callback(parsedArgs.args, block);
    return Object.assign({ _i: line.length + (block ? block._i : 0), code, comment: parsedArgs.comment }, response);
};
exports.parse = parse;
//# sourceMappingURL=parse.js.map